import { Doughnut } from "vue-chartjs";

export default {
  extends: Doughnut,
  props: ["options", "data"],
  mounted() {
    this.render();
  },
  computed: {
    chartData: function() {
      return this.data;
    },
    chartOptions: function() {
      return this.options;
    }
  },
  watch: {
    chartData: function() {
      this.$data._chart.destroy();
      this.render();
    },
    chartOptions: function() {
      this.$data._chart.destroy();
      this.render();
    }
  },
  methods: {
    render: async function() {
      await this.renderChart(this.chartData, this.chartOptions);
    }
  }
};
